var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import id from "@irati/utils/id";
import { Body, H3 } from "@irati/ui/src/Typography";
import Button from "@irati/ui/src/Button";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import Flex from "@irati/ui/src/Flex";
import walletBadge from "@irati-web/wallet/src/images/wallet_badge.svg";
import { FormattedMessage, FormattedCurrency } from "@irati/utils/lang";
import { connect } from "@irati/store";
import dealsService from "@irati/deals/services/dealsGraph";
import { DealStatus } from "@irati/types";
import StyledSectionHeader, { GridWrapper, Primary, Image } from "./styled/SectionHeader";
import { AvailableBalance } from "./styled/SpendSectionHeader";
import { navigateToCategoryWithTag } from "../../helpers/categories/navigateToCategoryWithTag";
var INITIAL_VARIABLES = { statuses: [DealStatus.On, DealStatus.Unavailable], limit: 1 };
var SpendSectionHeader = /** @class */ (function (_super) {
    __extends(SpendSectionHeader, _super);
    function SpendSectionHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dealCount: undefined
        };
        return _this;
    }
    SpendSectionHeader.prototype.componentDidMount = function () {
        var _this = this;
        dealsService
            .list(__assign(__assign({}, INITIAL_VARIABLES), { tags: [this.props.tag.uuid] }))
            .then(function (_a) {
            var count = _a.count;
            _this.setState({
                dealCount: count
            });
        });
    };
    SpendSectionHeader.prototype.render = function () {
        var _this = this;
        var idNamespace = id("spend-section-header", this.props);
        var _a = this.props, headerText = _a.headerText, className = _a.className, _b = _a.wallet, availableBalance = _b.availableBalance, currency = _b.currency, tag = _a.tag;
        var dealCount = this.state.dealCount;
        return (React.createElement(StyledSectionHeader, { id: idNamespace, className: className },
            React.createElement(GridWrapper, null,
                React.createElement(Primary, null,
                    React.createElement(Image, { src: walletBadge }),
                    React.createElement("div", null,
                        React.createElement(H3, { id: id("title", idNamespace), paddingBottom: 1 }, headerText),
                        React.createElement(Body, { small: true }, availableBalance === 0 ? (React.createElement(FormattedMessage, { id: "perks.spendSectionHeader.subText.noBalance" })) : (React.createElement(FormattedMessage, { id: "perks.spendSectionHeader.subText.withBalance", values: {
                                availableBalance: (React.createElement(AvailableBalance, null,
                                    React.createElement(FormattedCurrency, { isCents: false, currency: currency, value: availableBalance })))
                            } }))))),
                tag && (React.createElement(Button, { cta: true, onClick: function () { return navigateToCategoryWithTag(tag, _this.context); } },
                    React.createElement(Flex, { alignItems: "center" },
                        React.createElement(FormattedMessage, { id: "perks.spendSectionHeader.seeAllButton.text", values: { count: dealCount } }),
                        React.createElement(Icon, { icon: IconTypes.arrowRight, marginLeft: true })))))));
    };
    SpendSectionHeader.contextTypes = {
        appPath: PropTypes.string.isRequired
    };
    SpendSectionHeader.defaultProps = {
        className: null,
        tag: null
    };
    return SpendSectionHeader;
}(PureComponent));
var mapStateToProps = function (_a) {
    var wallet = _a.wallet;
    return ({ wallet: wallet });
};
export default connect(mapStateToProps)(SpendSectionHeader);
